import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import styles from "./manufactureSel.module.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deletevendorData, getManufacturerThunk, setVendorData } from "../../redux/vendorSlice";
import { CloseCircle } from "../../../Svg";
import api from "../../utils/api";


const ManufactureSel = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const vendorData = useSelector((state) => state.vendor.vendorData);
    const { manufacturers } = useSelector((state) => state.vendor)
    const [selectedManufacturers, setSelectedManufacturersState] = useState(vendorData.selectedManufacturers);
    const { appearences } = useSelector((state) => state.appearences)

    console.log(selectedManufacturers);
    const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : manufacturers?.filter(customer =>
                customer?.name?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };

    useEffect(() => {
        dispatch(getManufacturerThunk())
    }, [])


    console.log(manufacturers);


    useEffect(() => {
        setSelectedManufacturersState(vendorData.selectedManufacturers || []);
    }, [vendorData]);



    const handleSelectionChange = (manufacturer) => {
        setSelectedManufacturersState((prevSelected) => {
            const isSelected = prevSelected.some((item) => item._id === manufacturer._id);

            if (isSelected) {
                return prevSelected.filter((item) => item._id !== manufacturer._id);
            } else {
                return [...prevSelected, { _id: manufacturer._id, name: manufacturer.name }];
            }
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const selecteManufacturerID = selectedManufacturers?.map((i) => i?._id)
        const dataToSend = {
            ...vendorData,
            manufacturers: selecteManufacturerID,
        };
        try {
            setLoading(true)
            const response = await api.vendorRegister(dataToSend)
            if (response.data) {
                console.log("vendor registration data", response?.data?.data);
                toast?.success(response.data?.data?.message)
                dispatch(deletevendorData())
                navigate('/login')
            }
        } catch (err) {
            console.log("vendor registration error", err?.response);
            toast.error(err?.response?.data?.message || "something went wrong")
        } finally {
            setLoading(false)
        }

    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };



    return (
        <>
            <div
                className={styles.loginContainer}
                style={{
                    backgroundImage: `url(${appearences?.loginBanner?.image || '/assets/login.png'})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundAttachment: "fixed",
                    backgroundSize: 'cover',
                    // height: '100vh',
                }}
            >
                <div className={styles.loginInner}>
                    <div className={styles.loginCol1} onClick={() => navigate('/')}>
                        <img src="/assets/logo.jpg" alt="Logo" />
                    </div>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>
                            <div className={styles.loginCardHead}>
                                <h3>Vendor Registration</h3>
                            </div>
                            <div className={styles.hrseparator}></div>
                            <div className={styles.loginContent}>
                                <form className={styles.loginForm}>
                                    <p>Manufacture Selections</p>
                                    <div className={styles.customSelect} ref={dropdownRef}>
                                        <div
                                            className={styles.dropdownHeader}
                                            onClick={handleToggleDropdown}
                                        >
                                            Select
                                            <div className={styles.selectArrowIcon}>
                                                <svg
                                                    width="19"
                                                    height="21"
                                                    viewBox="0 0 19 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1 0L4 3L7 0"
                                                        stroke="#999999"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                        <div>
                                            <span style={{ color: '#666666', fontSize: 12 }}>can Select multiple manufactures</span>
                                        </div>
                                        <div style={{
                                            display: 'flex', flexWrap: 'wrap', marginTop: 10, marginBottom: 10,
                                            gap: 10,
                                        }}>
                                            {
                                                selectedManufacturers?.map((i) => (
                                                    <div className={styles.selectedname}>
                                                        {i?.name}
                                                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleSelectionChange(i)}>
                                                            {CloseCircle()}

                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {isOpen && (
                                            <div className={styles.dropdownContent}>
                                                <div style={{}}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search..."
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px',
                                                            boxSizing: 'border-box',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px',
                                                            background: "#333",
                                                            color:'white'
                                                        }}
                                                        value={searchTerm}
                                                        onChange={handleSearchChange}
                                                    />
                                                </div>
                                                <div style={{ maxHeight: "250px", overflowY: "scroll" }}>
                                                {(filteredData || manufacturers)?.map((manufacturer) => (
                                                   
                                                        <label
                                                            key={manufacturer._id}
                                                            className={styles.dropdownItem}
                                                        >
                                                            {manufacturer.name}
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedManufacturers.some((item) => item._id === manufacturer._id)}
                                                                onChange={() => handleSelectionChange(manufacturer)}
                                                            />
                                                        </label>
                                                    ))}


                                                </div>
                                                <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                                    <button
                                                        className={styles.loginButton}
                                                        onClick={() => setIsOpen(false)}
                                                        style={{ borderRadius: "0px" }}
                                                    >
                                                        {'Submit '}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </form>
                                <div className={styles.loginAccLinks}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <div>
                                            <button
                                                type="button"
                                                className={styles.loginButtonStroke}
                                                onClick={() => navigate(-1)}
                                            >
                                                Back
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                type="submit"
                                                className={styles.loginButton}
                                                onClick={handleSubmit}
                                            >
                                                {loading ? 'please wait...' : 'Register'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ManufactureSel;
